import { defineComponent as o, createBlock as r, openBlock as n, unref as p, mergeProps as i, withCtx as l, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const V = /* @__PURE__ */ o({
  name: "IconEqualizer",
  __name: "IconEqualizer",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (n(), r(p(c), i(t, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        m("path", { d: "M17.75 5a.75.75 0 0 0-1.5 0v1.25H3a.75.75 0 0 0 0 1.5h13.25V9a.75.75 0 0 0 1.5 0V7.75H21a.75.75 0 0 0 0-1.5h-3.25V5M3 16.25a.75.75 0 0 0 0 1.5h9.25V19a.75.75 0 0 0 1.5 0v-1.25H21a.75.75 0 0 0 0-1.5h-7.25V15a.75.75 0 0 0-1.5 0v1.25H3M2.25 12A.75.75 0 0 1 3 11.25h3.25V10a.75.75 0 0 1 1.5 0v1.25H21a.75.75 0 0 1 0 1.5H7.75V14a.75.75 0 0 1-1.5 0v-1.25H3A.75.75 0 0 1 2.25 12" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  V as default
};
